import React from 'react';

const CloseModalButton = ({ handleClick, className = 'top-4 right-4' }) => {
  return (
    <img className={ `icon-close absolute cursor-pointer ${className}`} 
      onClick={() => handleClick()} 
      alt="Close"
      aria-label="Close" />
  );
};

export default CloseModalButton;
